// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"ReviewSliderDes-module-sliderWrapper--ebiMp","image":"ReviewSliderDes-module-image--EO3gt"};